import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import VideocamIcon from '@mui/icons-material/Videocam';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MessageIcon from '@mui/icons-material/Message';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import CreateIcon from '@mui/icons-material/Create';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChecklistIcon from '@mui/icons-material/Checklist';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import LogoutIcon from '@mui/icons-material/Logout';
import ScheduleIcon from '@mui/icons-material/Schedule';

// Navigation items for patient role
export const patientNavItems = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: <DashboardIcon />,
    path: '/dashboard'
  },
  {
    id: 'appointments',
    label: 'Appointments',
    icon: <CalendarMonthIcon />,
    path: '/appointments'
  },
  {
    id: 'medical',
    label: 'Medical',
    icon: <MedicalServicesIcon />,
    path: '#',
    children: [
      {
        id: 'health-stats',
        label: 'Health Stats',
        icon: <AssignmentIcon />,
        path: '/health-stats',
        comingSoon: true
      },
      {
        id: 'prescriptions',
        label: 'Prescriptions',
        icon: <LocalPharmacyIcon />,
        path: '/prescriptions'
      },
      {
        id: 'notes',
        label: 'Notes',
        icon: <NoteAltIcon />,
        path: '/notes'
      },
      {
        id: 'records',
        label: 'Health Records',
        icon: <DescriptionIcon />,
        path: '/records',
        comingSoon: true
      },
      {
        id: 'healthcare-services',
        label: 'Healthcare Services',
        icon: <BusinessIcon />,
        path: '/healthcare-services',
        comingSoon: true
      },
      {
        id: 'lifestyle',
        label: 'Lifestyle & Support',
        icon: <PeopleIcon />,
        path: '/lifestyle',
        comingSoon: true
      }
    ]
  },
  {
    id: 'communication',
    label: 'Communication',
    icon: <MessageIcon />,
    path: '#',
    children: [
      {
        id: 'messages',
        label: 'Messages',
        icon: <MessageIcon />,
        path: '/messages'
      },
      {
        id: 'video',
        label: 'Video Calls',
        icon: <VideocamIcon />,
        path: '/video-call'
      }
    ]
  },
  {
    id: 'profile',
    label: 'Profile',
    icon: <PersonIcon />,
    path: '/profile'
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: <SettingsIcon />,
    path: '/settings'
  },
  {
    id: 'contact',
    label: 'Contact Us',
    icon: <ContactSupportIcon />,
    path: '/contact'
  },
  {
    id: 'admin-access',
    label: 'Admin Tools',
    icon: <AdminPanelSettingsIcon />,
    path: '/admin',
    requiresRole: 'super_admin',
    highlight: true
  }
];

// Navigation items for physician role
export const physicianNavItems = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: <DashboardIcon />,
    path: '/clinic-dashboard'
  },
  {
    id: 'patients',
    label: 'Patients',
    icon: <PeopleIcon />,
    path: '/physician/patients',
    comingSoon: true
  },
  {
    id: 'appointments',
    label: 'Appointments',
    icon: <CalendarMonthIcon />,
    path: '/appointments?userType=physician'
  },
  {
    id: 'schedule',
    label: 'My Schedule',
    icon: <ScheduleIcon />,
    path: '/physician/schedule'
  },
  {
    id: 'clinical',
    label: 'Clinical',
    icon: <MedicalServicesIcon />,
    path: '#',
    children: [
      {
        id: 'prescriptions',
        label: 'Prescriptions',
        icon: <LocalPharmacyIcon />,
        path: '/prescriptions?userType=physician'
      },
      {
        id: 'notes',
        label: 'Clinical Notes',
        icon: <NoteAltIcon />,
        path: '/notes?userType=physician'
      },
      {
        id: 'records',
        label: 'Medical Records',
        icon: <DescriptionIcon />,
        path: '/physician/records',
        comingSoon: true
      }
    ]
  },
  {
    id: 'communication',
    label: 'Communication',
    icon: <MessageIcon />,
    path: '#',
    children: [
      {
        id: 'messages',
        label: 'Messages',
        icon: <MessageIcon />,
        path: '/messages?userType=physician'
      },
      {
        id: 'video',
        label: 'Video Calls',
        icon: <VideocamIcon />,
        path: '/video-call?userType=physician'
      }
    ]
  },
  {
    id: 'profile',
    label: 'Profile',
    icon: <PersonIcon />,
    path: '/profile'
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: <SettingsIcon />,
    path: '/settings'
  },
  {
    id: 'admin-access',
    label: 'Admin Tools',
    icon: <AdminPanelSettingsIcon />,
    path: '/admin',
    requiresRole: 'super_admin',
    highlight: true
  }
];

// Navigation items for sponsor role
export const sponsorNavItems = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    icon: <DashboardIcon />,
    path: '/sponsor-dashboard'
  },
  {
    id: 'family',
    label: 'Family Members',
    icon: <PeopleIcon />,
    path: '/sponsor/family',
    comingSoon: true
  },
  {
    id: 'appointments',
    label: 'Appointments',
    icon: <CalendarMonthIcon />,
    path: '/appointments?userType=sponsor'
  },
  {
    id: 'communication',
    label: 'Communication',
    icon: <MessageIcon />,
    path: '#',
    children: [
      {
        id: 'messages',
        label: 'Messages',
        icon: <MessageIcon />,
        path: '/messages?userType=sponsor'
      },
      {
        id: 'video',
        label: 'Video Calls',
        icon: <VideocamIcon />,
        path: '/video-call?userType=sponsor'
      }
    ]
  },
  {
    id: 'payments',
    label: 'Payments',
    icon: <BusinessIcon />,
    path: '/sponsor/payments',
    comingSoon: true
  },
  {
    id: 'profile',
    label: 'Profile',
    icon: <PersonIcon />,
    path: '/profile'
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: <SettingsIcon />,
    path: '/settings'
  },
  {
    id: 'contact',
    label: 'Contact Us',
    icon: <ContactSupportIcon />,
    path: '/sponsor/contact'
  },
  {
    id: 'admin-access',
    label: 'Admin Tools',
    icon: <AdminPanelSettingsIcon />,
    path: '/admin',
    requiresRole: 'super_admin',
    highlight: true
  }
];

// Navigation items for admin role
export const adminNavItems = [
  {
    id: 'dashboards',
    label: 'View As',
    icon: <DashboardIcon />,
    path: '#',
    requiresRole: 'super_admin',  // Only super admins can switch views
    children: [
      {
        id: 'physician-dashboard',
        label: 'Physician Dashboard',
        icon: <MedicalServicesIcon />,
        path: '/clinic-dashboard'
      },
      {
        id: 'clinic-staff-dashboard',
        label: 'Clinic Staff Dashboard',
        icon: <BusinessIcon />,
        path: '/clinic-staff-dashboard',
        needsSelection: true  // Needs clinic selection
      },
      {
        id: 'patient-dashboard',
        label: 'Patient Dashboard',
        icon: <PersonIcon />,
        path: '/dashboard',
        needsSelection: true  // Needs patient selection
      },
      {
        id: 'sponsor-dashboard',
        label: 'Sponsor Dashboard',
        icon: <BusinessIcon />,
        path: '/sponsor-dashboard',
        needsSelection: true  // Needs sponsor selection
      }
    ]
  },
  {
    id: 'admin',
    label: 'Admin Panel',
    icon: <AdminPanelSettingsIcon />,
    path: '/admin',
    highlight: true,
  },
  {
    id: 'users',
    label: 'User Management',
    icon: <PeopleIcon />,
    path: '#',
    children: [
      {
        id: 'patients',
        label: 'Patients',
        icon: <PersonIcon />,
        path: '/admin/patients'
      },
      {
        id: 'physicians',
        label: 'Physicians',
        icon: <MedicalServicesIcon />,
        path: '/admin/physicians'
      },
      {
        id: 'sponsors',
        label: 'Sponsors',
        icon: <BusinessIcon />,
        path: '/admin/sponsors'
      }
    ]
  },
  {
    id: 'appointments',
    label: 'Appointments',
    icon: <CalendarMonthIcon />,
    path: '/appointments?userType=physician'
  },
  {
    id: 'clinical',
    label: 'Clinical',
    icon: <MedicalServicesIcon />,
    path: '#',
    children: [
      {
        id: 'prescriptions',
        label: 'Prescriptions',
        icon: <LocalPharmacyIcon />,
        path: '/prescriptions?userType=physician'
      },
      {
        id: 'notes',
        label: 'Clinical Notes',
        icon: <NoteAltIcon />,
        path: '/notes?userType=physician'
      },
      {
        id: 'records',
        label: 'Medical Records',
        icon: <DescriptionIcon />,
        path: '/physician/records',
        comingSoon: true
      }
    ]
  },
  {
    id: 'communication',
    label: 'Communication',
    icon: <MessageIcon />,
    path: '#',
    children: [
      {
        id: 'messages',
        label: 'Messages',
        icon: <MessageIcon />,
        path: '/messages?userType=physician'
      },
      {
        id: 'video',
        label: 'Video Calls',
        icon: <VideocamIcon />,
        path: '/video-call?userType=physician'
      }
    ]
  },
  {
    id: 'profile',
    label: 'Profile',
    icon: <PersonIcon />,
    path: '/profile'
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: <SettingsIcon />,
    path: '/settings'
  },
  {
    id: 'documentation',
    label: 'Documentation',
    icon: <DescriptionIcon />,
    path: '/documentation',
    requiresRole: 'super_admin'  // Only super admins can view documentation
  }
];
